/* @flow */

import React, { useEffect } from "react";
import styles from "../../../signups/src/routes/Thanks/Thanks.scss";
import Link from "../../../signups/src/components/Link";
import Avatar from "../../../signups/src/components/Avatar";
import { connect } from "react-redux";
import type { RootState } from "../types";

type ThanksProps = {
  store: RootState
};

const Thanks = ({
  store: {
    formState: {
      values: { businessLocation }
    }
  }
}: ThanksProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.flag}>
        <Avatar
          size="large"
          src={`https://assets.braintreegateway.com/images/country-flags/96/${businessLocation.code.toLowerCase()}.png`}
        />
      </div>
      <h1>Thanks for trying Braintree!</h1>

      <div className={styles.subheading}>
        <h2>Next step: check your inbox</h2>
        <p>
          We sent you an email that includes a link to activate your login to
          our sandbox environment and online signup process.
        </p>

        <p>
          You might also be interested in reviewing our{" "}
          <Link
            href="https://developers.braintreepayments.com/"
            intent="simple"
            target="_blank">
            API docs
          </Link>
          .
        </p>

        <p>
          If you have any questions about logging-in or working with our
          gateway, please submit a request to our{" "}
          <Link
            href="https://developer.paypal.com/braintree/help/sandboxHelp?initial_referrer=https%3A%2F%2Fdeveloper.paypal.com%2F&referrer=https%3A%2F%2Fapply.braintreegateway.com%2F"
            intent="simple"
            target="_blank">
            Help Center
          </Link>
          .
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = (store: RootState) => ({
  store
});

// $FlowFixMe
export default connect(mapStateToProps)(Thanks);
